
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap";
import 'bootstrap-icons/font/bootstrap-icons';
import 'bootstrap-icons/font/bootstrap-icons.css';

import 'v-calendar/dist/style.css';

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ArgonDashboard from "./plugins/argon-dashboard";
import "element-plus/lib/theme-chalk/index.css";


import store from './store';
import i18n from './contents/contents'
import FlagIcon from 'vue-flag-icon';
import VCalendar from 'v-calendar';
import VueGoogleMaps from '@fawmi/vue-google-maps'
import Vue3MobileDetection from "vue3-mobile-detection";
import { loadGoogleCharts } from 'vue-google-charts'
import Popper from "vue3-popper";

loadGoogleCharts('current', { packages: ['corechart'] })

// Register components in your 'main.js'
const maps_api_key = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

const appInstance = createApp(App);
appInstance.use(router);
appInstance.use(Popper);
appInstance.use(ArgonDashboard);
appInstance.use(store);
appInstance.use(i18n);
appInstance.use(FlagIcon);
appInstance.use(VCalendar);
appInstance.use(Vue3MobileDetection);
appInstance.use(VueGoogleMaps, {
    load: {
        key: maps_api_key,
        libraries: "places"
    },
})
appInstance.mount('#app')


export default i18n;